import { render, staticRenderFns } from "./ImsTrades.vue?vue&type=template&id=db2b87cc&"
import script from "./ImsTrades.vue?vue&type=script&lang=js&"
export * from "./ImsTrades.vue?vue&type=script&lang=js&"
import style0 from "./ImsTrades.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports